const document = (callback) => {
  var html = "<div>Some stuff</div>";
  if (callback) callback(html);
};

const selection = (callback) => {
  var html = "<div>selection</div>";
  if (callback) callback(html);
};

const selectionAsText = (callback) => {
  var text = "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.";
  if (callback) callback(text);
};

export default {
  document,
  selection,
  selectionAsText
};
